/* MC ECOM — suggestions de recherche instantanees (API Shopify /search/suggest.json) */
(function () {
  var form = document.querySelector('.mc-msearch__form');
  if (!form) return;
  var input = form.querySelector('.mc-msearch__input');
  var panel = document.createElement('div');
  panel.className = 'mc-sugg';
  panel.setAttribute('role', 'listbox');
  panel.hidden = true;
  form.parentNode.appendChild(panel);

  var RACCOURCIS = ['adhésif', 'patch nasal', 'égouttoir', 'sac de voyage', 'râpe à coco'];
  var timer = null, dernier = '', ouvert = false;

  /* le XPF n'a pas de centimes : l'API renvoie deja le montant reel */
  function prix(v) {
    var n = typeof v === 'string' ? parseFloat(v.replace(/[^0-9.,]/g, '').replace(',', '.')) : v;
    if (!isFinite(n)) return '';
    return Math.round(n).toLocaleString('fr-FR') + ' XPF';
  }

  function fermer() { panel.hidden = true; ouvert = false; }

  function montrerRaccourcis() {
    panel.innerHTML =
      '<p class="mc-sugg__t">Recherches fréquentes</p><div class="mc-sugg__tags">' +
      RACCOURCIS.map(function (m) {
        return '<button type="button" class="mc-sugg__tag" data-q="' + m + '">' + m + '</button>';
      }).join('') + '</div>';
    panel.hidden = false; ouvert = true;
  }

  function rendre(produits, q) {
    if (!produits.length) {
      panel.innerHTML = '<p class="mc-sugg__vide">Aucun produit pour « ' + q.replace(/</g, '&lt;') + ' »</p>';
      panel.hidden = false; ouvert = true; return;
    }
    panel.innerHTML = produits.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      var stock = (p.tags || []).indexOf('EN STOCK') !== -1
        ? '<span class="mc-sugg__stk">EN STOCK</span>' : '';
      return '<a class="mc-sugg__i" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="mc-sugg__ph"></span>') +
        '<span class="mc-sugg__c"><span class="mc-sugg__n">' + p.title + '</span>' +
        '<span class="mc-sugg__m">' + prix(p.price) + stock + '</span></span></a>';
    }).join('') +
      '<a class="mc-sugg__all" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a>';
    panel.hidden = false; ouvert = true;
  }

  function chercher(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (input.value.trim() !== q) return;            /* reponse perimee */
        rendre((d.resources && d.resources.results && d.resources.results.products) || [], q);
      })
      .catch(fermer);
  }

  input.addEventListener('focus', function () {
    if (!input.value.trim()) montrerRaccourcis();
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { montrerRaccourcis(); return; }
    if (q === dernier) return;
    dernier = q;
    timer = setTimeout(function () { chercher(q); }, 220);
  });

  panel.addEventListener('click', function (e) {
    var tag = e.target.closest('.mc-sugg__tag');
    if (tag) { input.value = tag.dataset.q; dernier = ''; input.dispatchEvent(new Event('input')); input.focus(); }
  });

  document.addEventListener('click', function (e) {
    if (ouvert && !form.contains(e.target) && !panel.contains(e.target)) fermer();
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fermer(); input.blur(); } });
})();
